module.exports = __webpack_public_path__ + "img/temp-share.5f34bd92.svg";